import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/card')({
  beforeLoad: () => {
    throw redirect({
      to: '/grid',
      replace: true,
    })
  },
})
